module.exports = __webpack_public_path__ + "static/media/horse.48c3d811.jpg";